import { Trans } from '@lingui/react/macro';

import { type VendorSpendDataType } from '@/api/vendorSpend';
import { Button } from '@/components/buttons';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/Dialog';

type Props = {
  vendorSpendRow?: VendorSpendDataType;
  onDeleteVendorRow: (deletedVendorSpendRow: VendorSpendDataType) => void;
  onCancel: () => void;
};

const ConfirmDeleteRowDialog = ({ vendorSpendRow, onDeleteVendorRow, onCancel }: Props) => {
  return (
    <Dialog open={vendorSpendRow != null} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Trans>Delete Spend Data</Trans>
          </DialogTitle>
        </DialogHeader>
        <div>
          <Trans>
            Deleting will remove all spend data for <strong>{vendorSpendRow?.vendor.name}</strong>{' '}
            <strong>{vendorSpendRow?.vendor.channel?.name}.</strong> Are you sure you want to
            delete?
          </Trans>
        </div>
        <DialogFooter>
          <DialogClose
            render={
              <Button size="large">
                <Trans>Cancel</Trans>
              </Button>
            }
          />
          <Button
            size="large"
            variant="primary"
            danger
            onClick={() => onDeleteVendorRow(vendorSpendRow!)}
          >
            <Trans>Yes, Delete</Trans>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDeleteRowDialog;
